import { COUNTRY } from "./CountryConstant";

export const PAN_REGEX_PATTERN = '(^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$)|(^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$)';
export const TAN_REGEX_PATTERN = '(^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$)';
export const TDS_REGEX_PATTERN = '(^(([a-zA-Z]){4}|([a-zA-Z]){5})(([0-9]){3}|([0-9]){4})$)';
export const PF_ACCOUNT_PATTERN = '(^([A-Za-z]{2})([A-Za-z]{3})([0-9]{1,7})([0-9]{3})?([0-9]{1,7})$)';
export const PF_ACCOUNT_PATTERN_IMPORT = '^([A-Za-z]{2}[A-Za-z]{3}[0-9]{7}[0-9]{3}[0-9]{7})*$';
export const EPF_REGEX_PATTERN = '(^([a-zA-Z]){5}([0-9]){10}$)';
export const ESI_REGEX_PATTERN = '(^([0-9]){17}$)';
export const NUMBER_REGEX_PATTERN = '(^([0-9])+$)';
export const IFSC_PATTERN = '(^[A-Z]{4}0[A-Z0-9]{6}$)';
export const UPI_PATTERN = /^[\w.-]+@[\w.-]+$/;
export const SSN_PATTERN = '^(?!666|000|9\\d{2})\\d{3}-(?!00)\\d{2}-(?!0{4})\\d{4}$';
export const EIN_PATTERN = '^\\d{2}-\\d{7}$';
export const UAN_NUMBER_REGEX = "^([0-9]{12})*$";
export const SSN_REGEX = '^(?!666|000|9\\d{2})\\d{3}-(?!00)\\d{2}-(?!0{4})\\d{4}$';
export const IC_NUMBER_REGEX = '^\\d{6}\\-\\d{2}\\-\\d{4}$'
export const FLOATING_NUMBER_REGEX = `([0-9]*[.])?[0-9]+`;
export const PERCENTAGE = '^[0-9][0-9]?$|^100$';
export const NRIC_REGEX = /^[SFTG]\d{7}[A-Z]$/;
export const FIN_REGEX = /^[M]\d{7}[A-Z]$/;
export const MULTIPLE_OF_05 = /^(?:\d*\.([05])|0|[1-9]\d*)$/

export const ZIPCODE_REGEX = {
    IND: '(^([1-9]{1}[0-9]{5}|[1-9]{1}[0-9]{3}\\s[0-9]{3})$)'
};

export const ZIPCODE_REGEX_IMPORT = {
    [COUNTRY.IN]: '^([1-9]{1}[0-9]{5}|[1-9]{1}[0-9]{3}\\s[0-9]{3})$',
    [COUNTRY.US]: '[0-9]*',
    [COUNTRY.SG]: /^(\s*|\d+)*$/
};
export const BANK_ACCOUNT_NUMBER = {
    [COUNTRY.MY]: {
        rhbBank: '^[0-9]{6-16}$',
        publicBankBerhad: '^[0-9]{6-16}$',
        cimbBank: '^[0-9]{6-16}$',
        mayBank: '^[0-9]{6-16}$',
        uobBank: '^[0-9]{11}$',
        amBank: '^[0-9]{6-16}$'
    }
}
export const ROUTING_NUMBER_REGEX = {
    [COUNTRY.US]: '^(0[1-9]|1[0-2]|2[1-9]|3[0-2])([0-9]{7})*$',
    [COUNTRY.MY]: {
        rhbBank: {regex:'^[0-9]{3}$',errorMsg:'3 digit'},
        publicBankBerhad: {regex:'^[0-9]{3}$',errorMsg:'3 digit'},
        cimbBank: {regex:'^[0-9]{3,4}$',errorMsg:'3-4 digit'},
        mayBank: {regex:'^[0-9]{5}$',errorMsg:'5 digit'},
        uobBank: {regex:'^[0-9]{3}$',errorMsg:'3 digit'},
        amBank: {regex:'^[0-9]{3}$',errorMsg:'3 digit'}
    }
}
export const LOCATION_NAME_REGEX = `^.{1,50}$`
export const PHONE_NUMBER_REGEX = {
    [COUNTRY.MY]: /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/,
    [COUNTRY.SG]: /\+65(6|8|9)\d{7}$/
}